import type { UsageResourceTileConfig } from "./types";

// Pack catalog moved to core/billing/creditPacks so core checkout surfaces
// (credit-card gate, paywall) can sell the same packs; re-exported here for
// the dashboard's existing imports.
export { AI_CREDIT_PACK_OPTIONS } from "core/billing/creditPacks";

// Tile order mirrors the APPS-4585 prototype: GAU usage leads (and is
// the default-selected section), Deployed Apps second, AI Builders third.
export const USAGE_RESOURCE_TILES: UsageResourceTileConfig[] = [
  {
    key: "shared_ai_credits",
    title: "Shared GAUs",
    subtitle: "GAUs used from your team's shared pool",
    accentClassName:
      "border-[#0099ff] bg-white shadow-[0_0_0_4px_rgba(0,153,255,0.12),0_0_0_1px_#0099ff]",
    progressClassName: "bg-sky-500",
    mocked: true,
  },
  {
    key: "deployed_apps",
    title: "Deployed Apps",
    subtitle: "Apps currently deployed",
    accentClassName:
      "border-[#0099ff] bg-white shadow-[0_0_0_4px_rgba(0,153,255,0.12),0_0_0_1px_#0099ff]",
    progressClassName: "bg-sky-500",
  },
  {
    key: "ai_builders",
    title: "AI Builders",
    subtitle: "Users with AI Builder licenses assigned",
    accentClassName:
      "border-[#0099ff] bg-white shadow-[0_0_0_4px_rgba(0,153,255,0.12),0_0_0_1px_#0099ff]",
    progressClassName: "bg-sky-500",
  },
];
